import React, { useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { Button, HookFormInputGroup, HookSelectFormGroup } from "components";
import { FormContainer, FormContent } from "components/layout";
import {
	AddColumnToNormalizationFormFields,
	DebounceTimeout,
} from "globalConstants";
import { ColumnsDataTypes, ValueTypes } from "types";
import { required } from "validators/validation";

import useAddColumnToNormalization from "./useAddColumnToNormalization";

type AddColumnToNormalizationFormProps = {
	entityId: string;
	submitService: Function;
	onSuccess: Function;
};

export const AddColumnToNormalizationForm = ({
	entityId,
	submitService,
	onSuccess,
}: AddColumnToNormalizationFormProps) => {
	const formMethods = useForm({
		mode: "onBlur",
		reValidateMode: "onChange",
		shouldUnregister: false,
	});

	const { handleSubmit, register, formState, control } = formMethods;

	const { errors } = formState;

	const submit = useAddColumnToNormalization({
		onSuccess,
		submitService,
	});

	const onSubmit = useCallback(
		async values => {
			submit?.(values, entityId);
		},
		[entityId, submit],
	);

	const dataTypesOptions = ColumnsDataTypes.getOptions();
	const valueTypesOptions = ValueTypes.getOptions();

	const { columnFieldName, dataTypeFieldName, valueTypeFieldName } =
		AddColumnToNormalizationFormFields;

	return (
		<FormProvider {...formMethods}>
			<form onSubmit={handleSubmit(onSubmit)}>
				<FormContent className="modal-form-content">
					<FormContainer>
						<HookFormInputGroup
							label="Column Name"
							name={columnFieldName}
							placeholder="Enter Name"
							colLabel={12}
							colInput={12}
							register={register}
							autoComplete="off"
							validator={{
								required,
							}}
							showRequiredMark
							errors={errors}
						/>

						<HookSelectFormGroup
							label="Data Type"
							name={dataTypeFieldName}
							colLabel={{ sm: 12 }}
							colSelect={{ sm: 12 }}
							control={control}
							options={dataTypesOptions}
							getOptionLabel={option => option.displayName}
							getOptionValue={option => option.value}
							placeholder="Please Select"
							isSearchable={false}
							cacheOptions
							defaultOptions
							debounceTimeout={DebounceTimeout}
							rules={{
								validate: {
									required,
								},
							}}
							showRequiredMark
						/>

						<HookSelectFormGroup
							label="Data Type"
							name={valueTypeFieldName}
							colLabel={{ sm: 12 }}
							colSelect={{ sm: 12 }}
							control={control}
							options={valueTypesOptions}
							getOptionLabel={option => option.displayName}
							getOptionValue={option => option.value}
							placeholder="Please Select"
							isSearchable={false}
							cacheOptions
							defaultOptions
							debounceTimeout={DebounceTimeout}
							rules={{
								validate: {
									required,
								},
							}}
							showRequiredMark
						/>

						<div className="mt-4 text-center">
							<Button
								value="Save"
								type="submit"
								disabled={!formState.isDirty}
							/>
						</div>
					</FormContainer>
				</FormContent>
			</form>
		</FormProvider>
	);
};
